module.exports = __webpack_public_path__ + "distribution/img/ico_tip.178a208e.svg";